import { StoplightProject } from "@stoplight/elements-dev-portal";
import "@stoplight/elements-dev-portal/styles.min.css";
import "./Escrituradora.css"

function Bookvariaveis() {
  return (
    <div className="container">
      <StoplightProject projectId="cHJqOjMwNjkxMw" router="hash" />
    </div>
  );
}

export default Bookvariaveis;
